import { Suspense, useContext, useEffect } from "react";
import { PageSettingsContext } from "../../context/PageContext";
import Fallback from "../../pages/fallback";

export default function RouteElement({
	element,
	routeItems,
	pageSettings={
        footer: true,
        header: true,
        title: "Escrita & Pratica",
		draggable: true,
		floatingAnchor: true,
    }
}) {
	const pageCtx = useContext(PageSettingsContext);
	useEffect(() => {
		// pageCtx.setRouteItems(routeItems);
		pageCtx.setPageHeader(pageSettings.header);
		pageCtx.setPageFooter(pageSettings.footer);
		pageCtx.setDraggable(pageSettings.draggable);
		pageCtx.setFloatingAnchor(pageSettings.floatingAnchor);
		document.title = pageSettings.title;
		return () => {
			// pageCtx.setRouteItems([]);
			pageCtx.setPageHeader(true);
			pageCtx.setPageFooter(true);
			pageCtx.setDraggable(true);
			pageCtx.setFloatingAnchor(true);
			document.title = "Escrita & Pratica";
		}
	}, [pageCtx, pageSettings, routeItems]);

	return (
		<Suspense fallback={<Fallback />}>
				{element}
		</Suspense>
	);
}